var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "table-responsive",
        staticStyle: { "max-height": "300px" }
      },
      [
        _c("table", [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.items, function(item, index) {
                return _c("tr", { key: index }, [
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.codigo_barra) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.nombre_item) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.cantidad) +
                        "\n                    "
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.items.length === 0,
                      expression: "items.length === 0"
                    }
                  ]
                },
                [_vm._m(2)]
              )
            ],
            2
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.aceptar }
        },
        [
          _c("i", { staticClass: "fa fa-check" }),
          _c("span", [_vm._v("Aceptar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-danger btn--text", on: { click: _vm.cancelar } },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [_c("h3", [_vm._v("Ítems")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Cod. Barra")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ítem")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("strong", [_vm._v("No se ha encontrado ítems.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18d2a634", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18d2a634","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/AceptarItemsAdicionales.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-18d2a634","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/AceptarItemsAdicionales.vue
// module chunks = 0